import React, { useState } from 'react';
import ProductSearchScan from './ProductSearchScan';


const InvoiceForm = () => {
    const [invoiceProducts, setInvoiceProducts] = useState([]);
const [customer, setCustomer] = useState({ name: '', mobile: '', email: '' });


    const handleAddProduct = (product) => {
        setInvoiceProducts((prevProducts) => [
            ...prevProducts,
            { ...product, quantity: 1 } // Initialize with quantity 1
        ]);
    };

    const handleCustomerChange = (e) => {
        const { name, value } = e.target;
        setCustomer((prevCustomer) => ({
            ...prevCustomer,
            [name]: value
        }));
    };

    const handleQuantityChange = (e, productId) => {
        const updatedQuantity = parseInt(e.target.value, 10);
        if (updatedQuantity < 1) return;

        setInvoiceProducts((prevProducts) =>
            prevProducts.map((product) =>
                product.Product_ID === productId
                    ? { ...product, quantity: updatedQuantity }
                    : product
            )
        );
    };



const handleSubmit = async (e) => {
    e.preventDefault();

    // Build products with tax calculations
    const productsWithCalc = invoiceProducts.map((product) => {
        let subtotal, cgst, sgst, total;


if (product.Product_Type === "Books") {
    subtotal = (product.Product_Price * product.quantity).toFixed(2);
    cgst = (0).toFixed(2);
    sgst = (0).toFixed(2);
} else if (["Mugs"].includes(product.Product_Type)) {
    subtotal = ((product.Product_Price / 1.12) * product.quantity).toFixed(2);
    const tax = (product.Product_Price * product.quantity - subtotal).toFixed(2);
    cgst = (tax / 2).toFixed(2);
    sgst = (tax / 2).toFixed(2);
} else {
    subtotal = ((product.Product_Price / 1.05) * product.quantity).toFixed(2);
    const tax = (product.Product_Price * product.quantity - subtotal).toFixed(2);
    cgst = (tax / 2).toFixed(2);
    sgst = (tax / 2).toFixed(2);
}

total = (parseFloat(subtotal) + parseFloat(cgst) + parseFloat(sgst)).toFixed(2);


     return {
    Product_ID: product.Product_ID,
    Product_Name: product.Product_Name,
    Product_Price: product.Product_Price,
    quantity: product.quantity,
    subtotal: parseFloat(subtotal),
    cgst: parseFloat(cgst),
    sgst: parseFloat(sgst),
    total: parseFloat(total),
};

    });

    const invoiceData = {
        customer,
        products: productsWithCalc,
        total: productsWithCalc.reduce((sum, p) => sum + p.total, 0),
    };

    try {
        const response = await fetch("https://merch.tjdstore.in/api/Backend/save_invoice.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(invoiceData),
        });

        const data = await response.json();
if (data.success) {
    console.log("Invoice saved with ID:", data.invoice_id);

    // try {
    //     await fetch("https://merch.tjdstore.in/api/Backend/send_invoice.php", {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify({
    //             invoice_id: data.invoice_id,
    //             name: customer.name,
    //             mobile: customer.mobile,
    //             invoice_link: `https://merch.tjdstore.in/invoices/${data.invoice_id}.pdf`
    //         }),
    //     });
    // } catch (err) {
    //     console.error("Failed to send invoice via WATI:", err);
    // }

try {
  const emailResponse = await fetch(`https://merch.tjdstore.in/api/Backend/send_invoice_mail.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      invoice_id: data.invoice_id,
      name: customer.name,
      email: customer.email,
      mobile: customer.mobile,
      invoice_link: `https://merch.tjdstore.in/invoices/${data.invoice_id}.pdf`,
      products: productsWithCalc
    }),
  });

  const emailData = await emailResponse.json();
  if (emailData.success) {
    console.log("Invoice email sent successfully!");
  } else {
    console.error("Email send failed:", emailData.message);
  }
} catch (err) {
  console.error("Failed to send invoice email:", err);
}




    printInvoice();

    // ✅ Update stock after successful invoice print
    await updateProductStock();
}
 else {
            console.error("Failed to save invoice:", data.message);
            alert("Error saving invoice!");
        }
    } catch (error) {
        console.error("Error saving invoice:", error);
        alert("Error saving invoice!");
    }
};








const updateProductStock = async () => {
    try {
        const response = await fetch('https://merch.tjdstore.in/api/Backend/update_stock.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ products: invoiceProducts }),
        });

        const data = await response.json();
        if (data.success) {
            console.log("Stock updated successfully!");
        } else {
            console.error("Error updating stock:", data.message);
        }
    } catch (error) {
        console.error("Failed to update stock:", error);
    }
};

    

    const printInvoice = () => {
        const invoiceContent = document.getElementById('invoice-content').innerHTML;
        const printWindow = window.open('', '', 'height=700,width=900');
        printWindow.document.write('<html><head><title>Invoice</title>');
        printWindow.document.write('<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>');
        printWindow.document.write('</head><body>');
        printWindow.document.write(invoiceContent);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        setTimeout(() => {
            printWindow.print();
        }, 500); // 500ms delay
    };

    return (
        <div className="container mt-4">
            <h3 className="mb-3">GENERATE CUSTOMER INVOICE</h3>
            <form onSubmit={handleSubmit} className="border p-3 rounded shadow">
                <div className="mb-3">
                    <label className="form-label">Customer Name:</label>
                    <input className="form-control"
                        type="text"
                        name="name"
                        value={customer.name}
                        onChange={handleCustomerChange}
                        required
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">Mobile:</label>
                    <input className="form-control"
                        type="text"
                        name="mobile"
                        value={customer.mobile}
                        onChange={handleCustomerChange}
                        required
                    />
                </div>

                <div className="mb-3">
  <label className="form-label">Email:</label>
  <input
    className="form-control"
    type="email"
    name="email"
    value={customer.email || ""}
    onChange={handleCustomerChange}
    required
  />
</div>


                <ProductSearchScan addProductToInvoice={handleAddProduct} />

                <h4 className="mt-4">Invoice Products</h4>
                <table className="table table-bordered text-center">
                    <thead className="table-dark">
    <tr>
        <th>Product</th>
        <th>HSN/SAC</th>
        <th>Qty</th>
        <th>Size</th>
        <th>Subtotal</th>
        <th>CGST</th>
        <th>SGST</th>
        <th>Total</th>
    </tr>
</thead>

<tbody>
    {invoiceProducts.map((product, index) => {
        let subtotal, cgst, sgst, total;

if (product.Product_Type === 'Books') {
    subtotal = (product.Product_Price * product.quantity).toFixed(2);
    cgst = (0).toFixed(2);
    sgst = (0).toFixed(2);
} else if (['Mugs'].includes(product.Product_Type)) {
    subtotal = ((product.Product_Price / 1.12) * product.quantity).toFixed(2);
    const tax = (product.Product_Price * product.quantity - subtotal).toFixed(2);
    cgst = (tax / 2).toFixed(2);
    sgst = (tax / 2).toFixed(2);
}  else if (['Jewellery'].includes(product.Product_Type)) {
    subtotal = ((product.Product_Price / 1.03) * product.quantity).toFixed(2);
    const tax = (product.Product_Price * product.quantity - subtotal).toFixed(2);
    cgst = (tax / 2).toFixed(2);
    sgst = (tax / 2).toFixed(2);
}
 else {
    subtotal = ((product.Product_Price / 1.05) * product.quantity).toFixed(2);
    const tax = (product.Product_Price * product.quantity - subtotal).toFixed(2);
    cgst = (tax / 2).toFixed(2);
    sgst = (tax / 2).toFixed(2);
}

total = (parseFloat(subtotal) + parseFloat(cgst) + parseFloat(sgst)).toFixed(2);


        return (
            <tr key={index}>
                <td>{product.Product_Name}</td>
                <td>{product.Product_HSN}</td>
                <td>
                    <input
                        type="number"
                        value={product.quantity}
                        onChange={(e) => handleQuantityChange(e, product.Product_ID)}
                        min="1"
                        style={{ width: '50px' }}
                    />
                </td>
                <td>{product.Product_Size}</td>
                <td>₹{subtotal}</td>
<td>₹{cgst}</td>
<td>₹{sgst}</td>
<td>₹{total}</td>

            </tr>
        );
    })}
</tbody>



                </table>

                <h4 className="mt-3">Total Amount: ₹
                    {invoiceProducts.reduce((total, product) => total + product.Product_Price * product.quantity, 0).toFixed(2)}
                </h4>

                <button className="btn btn-success mt-3" type="submit">Print Invoice</button>
            </form>

            {/* Printable Invoice Design */}
            <div id="invoice-content" style={{ display: 'none' }}>
                <div className="container p-3 border">
                    <div className="text-center">
                        <img src="https://st.tjdstore.in/images/jd-logo.png" width="200" alt="Company Logo" className="mb-3" />
                        

                    </div>
                    <p className="txset"><span className="boldtx">JD DIGITAL PRIVATE LIMITED</span><br />
Company ID : U74999RJ2020PTC071151<br />
28, Basement, Palm Courts, Jagatpura<br />
Jaipur Rajasthan 302017<br />
India<br />
GSTIN 08AAECJ9462E1ZD</p>
                            
<p>Email: contact@jddigital.in | Whatsapp: +91 86193 17791</p>
<hr />
                    <h4>TAX INVOICE</h4>
                    <p>Bill To</p>
                    <p><strong> {customer.name}</strong><br />
                    <strong>Mobile:{customer.mobile}</strong> </p>
                    <span>Place Of Supply: Maharashtra</span>

                    <table className="table table-bordered text-center mt-3">
                        <thead className="table-secondary">
                            <tr>
                                <th>Product</th>
                                <th>HSN/SAC</th>                                                           
                                <th>Qty</th>
                                <th>Size</th>
                                <th>Subtotal</th>
                                <th>CGST</th>
                                <th>SGST</th>
                                <th>Total (Including GST)</th>
                            </tr>
                        </thead>
<tbody>
    {invoiceProducts.map((product, index) => {
        let subtotal, cgst, sgst, total;

if (product.Product_Type === 'Books') {
    subtotal = (product.Product_Price * product.quantity).toFixed(2);
    cgst = (0).toFixed(2);
    sgst = (0).toFixed(2);
} else if (['Mugs'].includes(product.Product_Type)) {
    subtotal = ((product.Product_Price / 1.12) * product.quantity).toFixed(2);
    const tax = (product.Product_Price * product.quantity - subtotal).toFixed(2);
    cgst = (tax / 2).toFixed(2);
    sgst = (tax / 2).toFixed(2);
} else {
    subtotal = ((product.Product_Price / 1.05) * product.quantity).toFixed(2);
    const tax = (product.Product_Price * product.quantity - subtotal).toFixed(2);
    cgst = (tax / 2).toFixed(2);
    sgst = (tax / 2).toFixed(2);
}

total = (parseFloat(subtotal) + parseFloat(cgst) + parseFloat(sgst)).toFixed(2);

        return (
            <tr key={index}>
                <td>{product.Product_Name}</td>
                <td>{product.Product_HSN}</td>
                <td>{product.quantity}</td>
                <td>{product.Product_Size}</td>
                <td>₹{subtotal}</td>
<td>₹{cgst}</td>
<td>₹{sgst}</td>
                <td>₹{total}</td>
            </tr>
        );
    })}
</tbody>



                    </table>

                    <h4 className="text-end mt-3">Total Amount: ₹
                        {invoiceProducts.reduce((total, product) => total + product.Product_Price * product.quantity, 0).toFixed(2)}
                    </h4>

                    <p className="text-center mt-4"><strong>Thank You for Your Purchase!</strong></p>
                </div>
            </div>
        </div>
    );
};

export default InvoiceForm;